import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 24px;
  box-sizing: border-box;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  box-shadow: 0 0.83px 4.16px 0 rgba(63, 65, 66, 0.2);
  height: 100%;
  background-color: ${({ theme, isTemplate }) => theme.bg.card};

  ${({ hasLink }) => hasLink && `cursor: pointer;`}
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 42px;
`;

export const ListContainer = styled.div`
  display: flex;
  column-gap: 55px;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
`;

export const TitleSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ isList }) => (isList ? "8px" : "17px")};
  padding: ${({ isList }) => (isList ? "12px 0px" : "0px")};
  flex: 1;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.title};
  font-size: ${({ isList }) => (isList ? "22px" : "18px")};
  font-weight: 600;
  line-height: 24px;
  position: relative;
`;

export const Subtitle = styled.div`
  color: #acacac;
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  position: relative;
  white-space: pre-line;
`;

export const DateIconContainer = styled.div`
  display: flex;
  flex-direction: ${({ isList }) => (isList ? "column" : "row")};
  position: relative;
  align-items: start;
`;

export const Date = styled.div`
  width: ${({ isList }) => (isList ? "55px" : "49px")};
  height: ${({ isList }) => (isList ? "55px" : "49px")};
  border-radius: ${({ isList }) => (isList ? "12px" : "10.7px")};
  background: ${({ bgClr }) => bgClr || "#003BFF"};
  color: ${({ textClr }) => textClr || "#fff"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: ${({ isList }) => (isList ? "14px" : "12.5px")};
  z-index: 1;

  .date-day {
    font-size: ${({ isList }) => (isList ? "20.5px" : "18.27px")};
  }
`;

export const IconEmojiContainer = styled.div`
  display: grid;
  place-items: center;
  width: ${({ isList }) => (isList ? "69px" : "49px")};
  height: ${({ isList }) => (isList ? "69px" : "49px")};
  z-index: ${({ isList }) => (isList ? "0" : "2")};
  border-radius: 100px;
  font-size: ${({ isList }) => (isList ? "36px" : "22px")};
  position: relative;
  background-color: ${({ isList }) => (isList ? "transparent" : "#fff")};

  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 100px;
    border: 1px solid ${({ theme }) => theme.text.brand}1a;
    background-color: ${({ clr, theme }) => {
      const color = clr || "#003BFF";
      const colorOpacity10 = color.slice(0, 7);
      return `${colorOpacity10}${theme.name === "light" ? "1a" : "33"}`;
    }};
  }

  svg {
    color: ${({ clr }) => clr || "#003BFF"};
  }
`;

export const TextArrowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  opacity: 0.4;

  path {
    stroke: ${({ theme }) => theme.text.title};
  }
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.text.title};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 18px;
  max-width: 20ch;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
`;
